import {
  HOME_TYPE,
  WORK_TYPE,
  OTHER_TYPE
} from 'components/common/constants/addressTypesConstants';
import includes from 'lodash/includes';

class ReservationReducerHelper {
  constructor(reservation) {
    this.reservation = reservation;
    return this;
  }

  setupDefaultParamsForReservationUpdate() {
    return {
      id: this.reservation.id,
      adults: this.reservation.adults,
      children: this.reservation.children,
      address: {
        phrase: this.reservation.address_phrase,
        selectedObject: {
          g: !this.reservation.address_details.isBusStop,
          value: this.getValueForSelectedObjectAddress(),
          fav: this.getValueForSpecificKey('fav'),
          type: this.getValueForSpecificKey('type'),
          label: this.reservation.address_phrase
        },
        postcode: this.getValueForSpecificKey('postcode'),
        street: null,
        error: null,
        lat: this.getValueForSpecificKey('lat'),
        lng: this.getValueForSpecificKey('lng')
      },
      price: this.reservation.price,
      selectedCardId: null,
      kidsSafety: {
        noNeedCarSeat: this.getKidsSafetyAmountByKey('no_need_car_seat'),
        cradle: this.getKidsSafetyAmountByKey('cradle'),
        seatWithSeatBelts: this.getKidsSafetyAmountByKey('seat_with_seat_belts'),
        seatWithoutSeatBelts: this.getKidsSafetyAmountByKey('seat_without_seat_belts'),
        carSeatPad: this.getKidsSafetyAmountByKey('car_seat_pad')
      }
    }
  }

  getValueForSelectedObjectAddress() {
    if (this.reservation.address_details.isBusStop) {
      return this.reservation.address_details.name;
    } else {
      return this.reservation.address_details.googlePlaceId;
    }
  }

  getValueForSpecificKey(key) {
    var isBusStop = this.reservation.address_details.isBusStop;
    switch (key) {
      case 'fav':
        if (isBusStop) {
          return null;
        } else {
          return includes(
            [HOME_TYPE, WORK_TYPE, OTHER_TYPE],
            this.reservation.address_details.type
          );
        }
      // ****************************************
      case 'type':
        if (isBusStop) {
          return null;
        } else {
          return this.reservation.address_details.type;
        }
      // ****************************************
      case 'lat':
        if (isBusStop) {
          return null;
        } else {
          return this.reservation.address_details.lat;
        }
      // ****************************************
      case 'lng':
        if (isBusStop) {
          return null;
        } else {
          return this.reservation.address_details.lng;
        }
      // ****************************************
      case 'postcode':
        if (isBusStop) {
          return null;
        } else {
          return this.reservation.address_details.postcode;
        }
    }
  }

  getKidsSafetyAmountByKey(key) {
    var upperKey = key.toUpperCase();
    for (var i = 0; i < this.reservation.reservation_seats.length; i++) {
      var seatObj = this.reservation.reservation_seats[i];
      if (seatObj.seat.name === upperKey) {
        return seatObj.amount;
      }
    }
    return 0;
  }
}

export default ReservationReducerHelper;
